// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"22652f50","369":"34314dcd"}[chunkId] + ".chunk.js";
};